import { FC, useMemo, useCallback } from 'react'
import { ADVISOR_FLOAT_PANE_TYPE, AdvisorFloatPane } from 'components/features/coaching/advisorMeeting/types/floatPane'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { AdvisorRequestPane } from 'components/features/coaching/advisorMeeting/AdvisorRequestPane/AdvisorRequestPane'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { MeetingDetailsPane } from 'components/features/coaching/advisorMeeting/MeetingDetailsPane/MeetingDetailsPane'
import { AdvisorDetailsPane } from 'components/features/coaching/advisor/AdvisorDetailsPane/AdvisorDetailsPane'

export const TYPED_PANE = {
  type: ADVISOR_FLOAT_PANE_TYPE,
}

type AdvisorFloatingPaneHostProps = {
}
export const AdvisorFloatingPaneHost: FC<AdvisorFloatingPaneHostProps> = (props) => {
  const {} = props

  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, TYPED_PANE)) as AdvisorFloatPane | null

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(killAllFloatingPanesActionCreator())
  }, [dispatch])

  switch (pane?.mode) {
    case 'request':
      return (
        <AdvisorRequestPane onClose={ handleClose } />
      )
    case 'meeting':
      return (
        <MeetingDetailsPane onClose={ handleClose } uid={ pane.uid } />
      )
    case 'advisor':
      return (
        <AdvisorDetailsPane onClose={ handleClose } onBack={ handleClose } uid={ pane.uid } />
      )
  }

  return null
}
